import { render, staticRenderFns } from "./GuideButton.vue?vue&type=template&id=3db0b846"
import script from "./GuideButton.vue?vue&type=script&lang=js"
export * from "./GuideButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports